import { useGuidedProfileCreation } from "~/pages/Compliance/flags";
import {
  ACCOUNT_TYPES,
  GUIDED_CREATION_EXCLUDED_INSTITUTION_TYPES,
  VIEWABLE_ACCOUNT_TO_ACCOUNT_TYPE,
} from "./constants";

export const useEntityAccountTypeOptions = () => {
  const guidedProfileCreation = useGuidedProfileCreation();

  if (!guidedProfileCreation) {
    return {
      accountTypes: ACCOUNT_TYPES,
      viewableToAccountType: VIEWABLE_ACCOUNT_TO_ACCOUNT_TYPE,
    };
  }

  const viewableToAccountType = Object.fromEntries(
    Object.entries(VIEWABLE_ACCOUNT_TO_ACCOUNT_TYPE).filter(
      ([, value]) => !GUIDED_CREATION_EXCLUDED_INSTITUTION_TYPES.has(value),
    ),
  );

  return {
    accountTypes: Object.keys(viewableToAccountType),
    viewableToAccountType,
  };
};
